import React, { useState, useEffect, useCallback } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import api from '../../services/api';

const TABS = [
  { to: '/trading/masterchef', label: 'Overview', end: true },
  { to: '/trading/masterchef/positions', label: 'Positions' },
  { to: '/trading/masterchef/staged', label: 'Staged Recovering' },
  { to: '/trading/masterchef/activity', label: 'Activity' },
  { to: '/trading/masterchef/ema', label: 'EMA Watchlist' },
  { to: '/trading/masterchef/settings', label: 'Settings' },
];

export default function MasterChefLayout() {
  const [dashboard, setDashboard] = useState(null);
  const [toggling, setToggling] = useState(false);

  const fetchStatus = useCallback(async () => {
    try {
      const res = await api.get('/masterchef/dashboard');
      setDashboard(res.data);
    } catch (err) {
      console.error('Failed to fetch MC status:', err);
    }
  }, []);

  useEffect(() => {
    fetchStatus();
    const interval = setInterval(fetchStatus, 30000);
    return () => clearInterval(interval);
  }, [fetchStatus]);

  const toggleAgent = async () => {
    setToggling(true);
    try {
      await api.post('/masterchef/toggle');
      await fetchStatus();
    } catch (err) {
      console.error('Failed to toggle:', err);
      alert('Failed to toggle Master Chef');
    } finally {
      setToggling(false);
    }
  };

  const d = dashboard || {};

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 mb-4">
        <div className="flex flex-wrap items-center gap-2">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Master Chef</h1>
          <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${
            d.enabled ? 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400'
          }`}>
            {d.status === 'running' ? 'Running' : 'Paused'}
          </span>
          {d.dryRun === false ? (
            <span className="px-2.5 py-1 text-xs font-bold rounded-full bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 border border-green-300 dark:border-green-700 flex items-center gap-1.5">
              <span className="relative flex h-2.5 w-2.5">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" />
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500" />
              </span>
              LIVE TRADES
            </span>
          ) : (
            <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300">
              Dry Run
            </span>
          )}
        </div>
        <button
          onClick={toggleAgent}
          disabled={toggling}
          className={`px-4 py-1.5 text-sm rounded-lg text-white self-start sm:self-auto ${
            d.enabled ? 'bg-red-600 hover:bg-red-700' : 'bg-green-600 hover:bg-green-700'
          } disabled:opacity-50`}
        >
          {toggling ? '...' : d.enabled ? 'Stop' : 'Start'}
        </button>
      </div>

      <nav className="flex gap-1 mb-6 border-b border-gray-200 dark:border-gray-700 overflow-x-auto">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) =>
              `px-4 py-2 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
                isActive
                  ? 'border-blue-600 text-blue-600 dark:text-blue-400 dark:border-blue-400'
                  : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
              }`
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>

      <Outlet context={{ dashboard, refreshDashboard: fetchStatus }} />
    </div>
  );
}
